import { AppRouter } from './routes';
import { Toaster } from '@/components/ui/sonner';
import ErrorBoundary from '@/components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <AppRouter />
      <Toaster position="top-right" />
    </ErrorBoundary>
  );
}

export default App;
